export const SERVER_TIMESTAMP_HEADER = 'x-timestamp';
export const AUTHORIZATION = 'Authorization';
export const X_USER_ID = 'x-user-id';
